import { createFileRoute } from '@tanstack/react-router'
import { CompanySwitcher } from '@/components/CompanySwitcher'
import { CreateOrderModal } from '@/components/CreateOrderModal'
import { KanbanBoard } from '@/components/KanbanBoard'
import { useDocumentMeta } from '@/hooks/useDocumentMeta'

export const Route = createFileRoute('/app/')({
  component: AppIndex,
})

function AppIndex() {
  useDocumentMeta({
    title: 'Recepção (Pátio) - AutoWash Pro',
    description: 'Gerencie veículos, serviços e status operacionais no pátio em tempo real.',
  })

  return (
    <div className="flex flex-col h-[calc(100vh-100px)] overflow-hidden">
      <div className="mb-6 px-4 pt-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h3 className="text-3xl font-bold tracking-tight text-white">Recepção (Pátio)</h3>
          <p className="text-slate-400 mt-1">
            Gerencie os veículos arrastando-os entre as colunas.
          </p>
        </div>
        <div className="flex items-center gap-4">
          <CompanySwitcher />
          <CreateOrderModal />
        </div>
      </div>

      {/* Kanban Board Container */}
      <div className="flex-1 overflow-hidden">
        <KanbanBoard />
      </div>
    </div>
  )
}
